import { Box, CircularProgress, Typography } from '@mui/material';

interface Props {
  message?: string;
  fullScreen?: boolean;
}

export function LoadingSpinner({ message, fullScreen }: Props) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={2} sx={fullScreen ? { minHeight: '60vh' } : { py: 8 }}>
      <CircularProgress size={40} thickness={4} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
}
